import React from 'react';
import classNames from 'classnames';

export interface RadioButtonProps {
  id: string;
  name: string;
  value: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

export function RadioButton({ id, name, value, checked, onChange, label, disabled }: RadioButtonProps) {
  return (
    <label
      htmlFor={id}
      className={classNames(
        'group relative w-full cursor-pointer select-none',
        disabled && 'cursor-not-allowed opacity-60',
      )}
    >
      {/* Actual form control (visually hidden, still focusable) */}
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="sr-only"
      />

      <div className={classNames('flex items-center transition')}>
        {/* Icon container */}
        <div className="flex aspect-square items-center justify-center rounded-full p-3 transition-colors hover:bg-gray-200">
          <span
            aria-hidden
            className={classNames(
              'inline-flex h-5 w-5 items-center justify-center rounded-full border-2 transition-colors',
              checked ? 'border-black' : 'border-black/50',
            )}
          >
            {/* Unchecked SVG */}
            <svg
              viewBox="0 0 24 24"
              className={classNames('h-3.5 w-3.5', checked ? 'hidden' : 'block')}
              xmlns="http://www.w3.org/2000/svg"
              fill="transparent"
              stroke="transparent"
              strokeWidth={2}
            >
              <circle cx={12} cy={12} r={7} />
            </svg>

            {/* Checked SVG */}
            <svg
              viewBox="0 0 24 24"
              className={classNames('h-3.5 w-3.5', checked ? 'block' : 'hidden')}
              xmlns="http://www.w3.org/2000/svg"
              fill="black"
              stroke="black"
            >
              <circle cx={12} cy={12} r={7} />
            </svg>
          </span>
        </div>
        <span className="flex min-w-0 flex-col">
          <span className="truncate text-base font-medium text-black/60">{label}</span>
        </span>
      </div>
    </label>
  );
}
export default RadioButton;
